module.exports = __webpack_public_path__ + "img/中国体育场馆协会@2x.43bcdb07.png";